<template>
  <article class="support" v-bind="$attrs">
    <slot name="top" />
    <div class="grid grid--container support__inner">
      <div class="row row--md-h-center">
        <div :class="`col ${fullWidth ? 'col-lg-12' : 'col--lg-8 col--md-10'}`">
          <slot />
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    fullWidth: Boolean,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss">
.support__inner {
  padding-bottom: 2.5rem;
  padding-top: 2.5rem;

  h2 {
    color: var(--g-color-primary);
  }

  a:not(.btn):not(.v-button) {
    text-decoration: underline;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
